import { createSelector } from "reselect";
import { sameGuid } from "contexts/orgFilter";

// Basic selectors
const selectGateways = (state) => state.gateways?.byId || {};

export const getAllGateways = createSelector(
  [selectGateways],
  (gateways) => {
    return Object.values(gateways);
  }
);

export const getGatewaysByOrganizationGuid = (organizationGuid) =>
  createSelector(
    [selectGateways],
    (gateways) => {
      return Object.values(gateways).filter(gateway => 
        sameGuid(gateway.customer?.customerGuid, organizationGuid)
      );
    }
  );